module.exports = __webpack_public_path__ + "img/POP-00015-2.548fd7f8.png";